import { Grid } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import PropTypes from 'prop-types';
import React from 'react';
import { parseDateOnlyToLocalDate, timestamp } from '../../../../utils/formatTime';
import { APPOINTMENT_DATEPICKER_LABEL, DATE_PICKER_SLOT_PROPS, PICKUP_DATEPICKER_LABEL } from '../constants';
import AppointmentDateTimePicker from './AppointmentDateTimePicker';
import YesNoToggle from './YesNoToggle';

AppointmentSection.propTypes = {
  hasExistingAppointment: PropTypes.bool,
  setHasExistingAppointment: PropTypes.func.isRequired,
  pickupTime: PropTypes.any,
  appointmentDateTime: PropTypes.any,
  setter: PropTypes.func.isRequired,
  seenByDate: PropTypes.any,
  setSeenByDate: PropTypes.func.isRequired,
  restrictedDates: PropTypes.array,
  restrictedDatesLoading: PropTypes.bool,
  setIsAllowedPickupDate: PropTypes.func,
  setIsAllowedAppointmentDate: PropTypes.func,
  FIELDS: PropTypes.object.isRequired,
  showAllWithoutToggle: PropTypes.bool,
  viewOnly: PropTypes.bool,
  isNewRequest: PropTypes.bool,
};

export default function AppointmentSection({
  hasExistingAppointment,
  setHasExistingAppointment,
  pickupTime,
  appointmentDateTime,
  setter,
  seenByDate,
  setSeenByDate,
  restrictedDates,
  restrictedDatesLoading,
  setIsAllowedPickupDate,
  setIsAllowedAppointmentDate,
  FIELDS,
  showAllWithoutToggle = false,
  viewOnly = false,
  isNewRequest = false,
}) {
  return (
    <Grid container spacing={2}>
      {!showAllWithoutToggle && (
        <Grid item>
          <YesNoToggle
            title="Existing Appointment?"
            setter={setHasExistingAppointment}
            value={hasExistingAppointment}
            disabled={viewOnly}
          />
        </Grid>
      )}
      {(hasExistingAppointment === true || showAllWithoutToggle) && (
        <>
          <Grid item>
            <AppointmentDateTimePicker
              label={PICKUP_DATEPICKER_LABEL}
              appointmentDateTime={pickupTime}
              setter={setter}
              field={FIELDS.PICKUP_TIME}
              restrictedDates={restrictedDates}
              isLoading={restrictedDatesLoading}
              setIsAllowedDate={setIsAllowedPickupDate}
              referenceDate={appointmentDateTime}
              viewOnly={viewOnly}
              isNewRequest={isNewRequest}
            />
          </Grid>
          <Grid item>
            <AppointmentDateTimePicker
              label={APPOINTMENT_DATEPICKER_LABEL}
              appointmentDateTime={appointmentDateTime}
              setter={setter}
              field={FIELDS.APPOINTMENT_DATE_TIME}
              restrictedDates={restrictedDates}
              isLoading={restrictedDatesLoading}
              setIsAllowedDate={setIsAllowedAppointmentDate}
              referenceDate={pickupTime}
              viewOnly={viewOnly}
              isNewRequest={isNewRequest}
            />
          </Grid>
        </>
      )}
      {(hasExistingAppointment === false || showAllWithoutToggle) && (
        <Grid item>
          <DatePicker
            disablePast
            label="Seen By Date"
            slotProps={DATE_PICKER_SLOT_PROPS}
            value={parseDateOnlyToLocalDate(seenByDate)}
            onChange={(value) => setSeenByDate(value ? timestamp(value) : null)}
            disabled={viewOnly}
          />
        </Grid>
      )}
    </Grid>
  );
}
